const concatQueryParamsToUrl = (
  url: string,
  queryParams: { [key: string]: string },
) => {
  if (Object.keys(queryParams).length === 0) {
    return url;
  }

  const queryString = new URLSearchParams(queryParams).toString();

  url.includes('?') ? (url += '&' + queryString) : (url += '?' + queryString);

  return url;
};

export default concatQueryParamsToUrl;
